<div class="login-container">
  <div class="login-card">

    <!-- LOGO -->
    <div class="login-logo">
      <img [src]="logo" alt="System Logo" />
    </div>

    <!-- HEADER -->
    <div class="login-header">
      <h3>{{ systemName }}</h3>
    </div>

    <!-- STATUS MESSAGE -->
    <div class="login-alert" [class.show]="int_flagDisableMessage()">
      {{ str_message() }}
    </div>

    <!-- LOGIN FORM -->
    <div class="login-form">
      <form [formGroup]="loginForm" autocomplete="off">

        <!-- USERNAME -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>User ID</mat-label>
          <input
            matInput
            type="text"
            formControlName="username"
            [maxlength]="int_len_username"
            (input)="usernameSignal.set($any($event.target).value); checkUserID_Delayed()"
          />
          <mat-error *ngIf="username?.touched && !username?.valid"></mat-error>
        </mat-form-field>

        <!-- PASSWORD -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Password</mat-label>

          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="password"
            [maxlength]="int_len_password"
            (input)="passwordSignal.set($any($event.target).value)"
          />

          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hidePassword = !hidePassword"
          >
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>

          <mat-error *ngIf="password?.touched && !password?.valid"></mat-error>
        </mat-form-field>

        <!-- BUTTON SECTION -->
        <div class="login-buttons">

          <!-- LOGIN BUTTON -->
          <button
            class="login-btn"
            type="button"
            [disabled]="disableLoginBtn() || bln_loading"
            (click)="onFormSubmit()"
          >
            <ng-container *ngIf="!bln_loading; else loginSpinner">
              LOGIN
            </ng-container>

            

            <ng-template #loginSpinner>
              <mat-progress-spinner
                class="spinner-inside-btn"
                diameter="20"
                mode="indeterminate"
                color="primary"
              ></mat-progress-spinner>
            </ng-template>
          </button>

          <!-- VALIDATE BUTTON -->
          <button
            class="login-btn"
            type="button"
            *ngIf="showValidateBtn()"
            [disabled]="bln_loading"
            (click)="ldapSubmit()"
          >
            <ng-container *ngIf="!bln_loading; else validateSpinner">
              VALIDATE
            </ng-container>

            <ng-template #validateSpinner>
              <mat-progress-spinner
                class="spinner-inside-btn"
                diameter="20"
                mode="indeterminate"
                color="accent"
              ></mat-progress-spinner>
            </ng-template>
          </button>

        </div>

        <div class="change-password">
          <a   
           [class.disabled-link]="disablePWDBtn() || bln_loading"
    (click)="!(disablePWDBtn() || bln_loading) && onChangePassword()"
            href="javascript:void(0)">
            Change Password
          </a>
        </div>

      </form>
    </div>

  </div>
</div>
